var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import ButtonAction from '../utilities/ButtonAction';
var selfStyles = require('./ButtonLogin.scss');
var ButtonLogin = (function (_super) {
    __extends(ButtonLogin, _super);
    function ButtonLogin(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isConnected: window.socket.connected,
        };
        _this.handleSocketConnect = _this.handleSocketConnect.bind(_this);
        _this.handleSocketDisconnect = _this.handleSocketDisconnect.bind(_this);
        return _this;
    }
    ButtonLogin.prototype.componentDidMount = function () {
        window.socket.on('connect', this.handleSocketConnect);
        window.socket.on('disconnect', this.handleSocketDisconnect);
    };
    ButtonLogin.prototype.componentWillUnmount = function () {
        window.socket.off(this.handleSocketConnect);
        window.socket.off(this.handleSocketDisconnect);
    };
    ButtonLogin.prototype.handleSocketConnect = function () {
        this.setState({ isConnected: true });
    };
    ButtonLogin.prototype.handleSocketDisconnect = function () {
        this.setState({ isConnected: false });
    };
    ButtonLogin.prototype.render = function () {
        return (React.createElement(ButtonAction, { width: '300px', className: selfStyles.buttonLogin, isDisabled: this.props.isDisabled || !this.state.isConnected, isWaiting: this.props.isFetching }, this.props.children));
    };
    return ButtonLogin;
}(React.Component));
export default ButtonLogin;



//////////////////
// WEBPACK FOOTER
// ./src/pages/components/Authentication/ButtonLogin.tsx
// module id = 207
// module chunks = 0